import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(({ spacing, palette }) => ({
  header: {
    backgroundColor: palette.common.white,
    padding: spacing(16, 24),
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderBottom: '1px solid #E0E0E0',
  },
  title: {
    color: palette.primary.main,
    fontSize: spacing(18),
    fontWeight: 600,
    textAlign: 'left',
  },
  closeIcon: {
    color: palette.gray[64],
    cursor: 'pointer',
  },
  content: {
    padding: spacing(24),
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(16),
  },
  mainTitle: {
    fontSize: spacing(16),
    fontWeight: 600,
    color: palette.text.primary,
  },
  link: {
    fontSize: spacing(14),
    color: palette.primary.main,
    textDecoration: 'none',
    marginBottom: spacing(16),
    display: 'inline-block',
    cursor: 'pointer',
    width: 'fit-content',
  },
  label: {
    fontSize: spacing(14),
    color: palette.gray[64],
    marginBottom: spacing(8),
    display: 'block',
    fontWeight: 600,
  },
  textArea: {
    width: '100%',
  },
  actions: {
    padding: spacing(16, 24),
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: spacing(16),
  },
  button: {
    borderRadius: spacing(24),
    height: spacing(48),
    fontWeight: 600,
  },
  buttonOutline: {
    border: `1px solid ${palette.gray[20]}`,
    color: palette.gray[64],
    '&:hover': {
      backgroundColor: palette.gray[4],
    },
  },
  uploadContainer: {
    border: `1px dashed ${palette.gray[20]}`,
    borderRadius: spacing(4),
    padding: spacing(16),
    backgroundColor: palette.gray[4],
  },
}))
